import BillingPositionsAbstractEditorController from './abstract-editor-controller';

export default class BillingPositionsCreateController extends BillingPositionsAbstractEditorController {
    $onInit() {
        super.$onInit();

        this._loadPosition();
    }

    _loadPosition() {
        this.loading = false;
    }

    doSave() {
        this.api
            .post(`billing/positions`, this.model)
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/positions/controllers/create-controller.js